import { useEffect, useRef, type RefObject } from 'react';

export function useClickOutside(
  ref: RefObject<HTMLElement | null>,
  onClickOutside: () => void
): void {
  const callbackRef = useRef(onClickOutside);

  // Escribir el ref durante el render no es seguro: React puede descartar un
  // render (StrictMode lo hace dos veces), y entonces el ref se queda con un
  // callback de un render que nunca llegó a pintarse. Se actualiza en un efecto
  // sin dependencias, que corre después de cada render y antes de que pueda
  // llegar cualquier mousedown.
  useEffect(() => {
    callbackRef.current = onClickOutside;
  });

  useEffect(() => {
    const handler = (event: MouseEvent) => {
      if (!ref.current) return;
      if (ref.current.contains(event.target as Node)) return;
      callbackRef.current();
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [ref]);
}
